import React from "react";

const Icon = ({ className, children }) => (
  <i aria-hidden="true" className={className}>
    {children}
  </i>
);

export default Icon;
